import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <p className="text-note font-medium tracking-widest text-grey-500 uppercase">404</p>
      <h1 className="text-h2 font-semibold">Page not found</h1>
      <p className="max-w-md text-body text-grey-600">
        The page you’re looking for doesn’t exist or may have moved. Check the URL, or head back
        home.
      </p>
      <Link
        to="/"
        className="rounded-pill bg-red-500 px-6 py-3 text-body-m font-medium text-white shadow-red-btn transition-colors hover:bg-red-700">
        Back to home
      </Link>
    </main>
  );
}
